
import { Component, OnInit, OnDestroy, Input, AfterViewInit, ViewChild, ElementRef, EventEmitter, Output, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { UserLogin } from '../../models/user-login.model';
import { ICD, MasterConfig, ResponseAPI, ErrorList, ICDStep3 } from '../../models/IDPReport.model';
import { SfDataService } from '../../services/sf-data.service';
import { AgentService, PreSubmitIssue } from '../../services/agent.service';
import { AiHintStateService } from '../../services/ai-hint-state.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Utilities } from '../../services/utilities';
import Swal from 'sweetalert2';

 



declare global {
  interface JQuery {
    datepicker(options?: any): any;
  }
}

interface JQuery<TElement = HTMLElement> {
  select2(options?: any): any;
}

interface JQuery {
  select2(options?: any): any;
}


// import custom validator to validate 
import { MustMatch } from '../../models/MustMatch';
import { dateNotLessThanTodayValidator } from '../../models/dateNotLessThanTodayValidator';
import { elevenDigitPhoneNumberValidator, tenDigitPhoneNumberValidator } from '../../phone-number-mask.directive';


@Component({
    selector: 'app-sf-icd-change-office-info',
    templateUrl: './sf-icd-change-office-info.component.html',
    styleUrls: ['./sf-icd-change-office-info.component.scss'],
    standalone: false
})
export class SfIcdChangeOfficeInfoComponent implements OnInit, AfterViewInit {
  icd = new ICDStep3();
  data = {
    name: 'John',
    age: 30
  };

  userLogin = new UserLogin(); id: string; q: string; fm: string; d: string;
  isLoading = false;
  isTestCampaign = false;
  isNew_DBA_Name = false;
  isRemove_DBA_Name = false;
  formResetToggle = true;
  modalClosedCallback: () => void;
  loginStatusSubscription: any;
  selectedCountry: string;
  selected_WC_details: string
  icdForm: FormGroup;
  section1Form: FormGroup;
  section2Form: FormGroup;
  section3Form: FormGroup;
  section4Form: FormGroup;
  section5Form: FormGroup;
  section6Form: FormGroup;

  @Input()
  isModal = false;
  submitted = false;
  ddlUSStates = [];
  ddlBest_Delivery_Time = [];
  ddlCAProvinence = [];

  Canada_campaignData = [];
  Canada_retailsData = [];

  PO_namesData = [];
  NC_namesData = [];
  RC_namesData = [];
  dbaRowsVisibility: boolean[]; // Tracks visibility of each row
  dbaRowsHighlight: boolean[];

  US_campaignData = [];
  US_retailsData = [];
  icd_o = new ICD();
  @Output() dataEmitter = new EventEmitter<any>();
  @Input() inputData: any;
  selectedFiles: FileList;
  validFiles: File[] = [];
  fileData: { attachment_FileName: string, attachment_Base64: string, attachment_Type: string, FileId?: string, Url?: string, status?: 'uploading' | 'uploaded' | 'error' }[] = [];
  maxFilesAllowed: number = 15; // Maximum number of files allowed
  maxFileSize: number = 10 * 1024 * 1024; // 10 MB max file size (FR3)
  // Staged upload-on-select state, keyed by form control name.
  uploadState: { [controlName: string]: 'uploading' | 'uploaded' | 'error' } = {};
  uploadError: { [controlName: string]: string } = {};
  // Per-control selection counter so a slow FileReader from a superseded selection is ignored (FR2).
  private uploadSeq: { [controlName: string]: number } = {};

  US_Retails_selectedItems: any[] = [];
  US_Retails_isSelectedItemsinvalid = false;
  Canada_Retails_selectedItems: any[] = [];
  Canada_Retails_isSelectedItemsinvalid = false;
  US_Campaigns_selectedItems: any[] = [];
  US_Campaigns_isSelectedItemsinvalid = false;
  Canada_Campaigns_selectedItems: any[] = [];
  Canada_Campaigns_isSelectedItemsinvalid = false;

  isOTPValid = false;
  btnDisplay = true;
  // Pre-submit review
  showPreSubmitReview = false;
  preSubmitIssues: PreSubmitIssue[] = [];
  preSubmitLoading = false;
  verificationState: { [controlName: string]: 'pending' | 'verifying' | 'pass' | 'fail' | 'warn' } = {};
  verificationIssues: { [controlName: string]: string[] } = {};
  private readonly VERIFIED_DOC_TYPES: { [controlName: string]: string } = {
    DBA_Doc0: 'DBADocument',
    DBA_Doc1: 'DBADocument',
    DBA_Doc2: 'DBADocument',
    DBA_Doc3: 'DBADocument',
    DBA_Doc4: 'DBADocument',
    DBA_Doc5: 'DBADocument',
    DBA_Doc6: 'DBADocument',
    DBA_Doc7: 'DBADocument',
    DBA_Doc8: 'DBADocument',
    DBA_Doc9: 'DBADocument',
  };

  public masterConfig: MasterConfig[] = [];

  maxRows = 10;
  rowsVisibility: boolean[] = []; // Tracks visibility of each row

  datad = {
    name: '',
    age: 0
  };

  @Output() idEmitter = new EventEmitter<string>();
  //@ViewChild('dobInput') dobInput: ElementRef;
  @ViewChild('datepicker') datepicker: ElementRef;
  @ViewChild('selectEl') selectEl: ElementRef;

  select2Options = {
    placeholder: 'Select an option...',
    width: '100%'
  };

  selectedOption: string;
  controlDisplayNames: { [key: string]: string } = {

    Owner_Email_N: 'Owner Email',
    Owner_Mobile_Phone_N: 'Owner Mobile Phone',
    Company_Office_Phone_N: 'Company Office Phone',
    Remove_DBA_Name: 'Remove DBA Name',

    isPreferredDBA: 'Is this the ICD\'s Preferred DBA?',
    preferredDBAName: 'Preferred DBA Name',

    New_DBA_Name0: 'New DBA Name',
    DBA_Doc0: 'DBA Document',

    New_DBA_Name1: 'New DBA Name',
    DBA_Doc1: 'DBA Document',

    New_DBA_Name2: 'New DBA Name',
    DBA_Doc2: 'DBA Document',

    New_DBA_Name3: 'New DBA Name',
    DBA_Doc3: 'DBA Document',

    New_DBA_Name4: 'New DBA Name',
    DBA_Doc4: 'DBA Document',

    New_DBA_Name5: 'New DBA Name',
    DBA_Doc5: 'DBA Document',

    New_DBA_Name6: 'New DBA Name',
    DBA_Doc6: 'DBA Document',

    New_DBA_Name7: 'New DBA Name',
    DBA_Doc7: 'DBA Document',

    New_DBA_Name8: 'New DBA Name',
    DBA_Doc8: 'DBA Document',

    New_DBA_Name9: 'New DBA Name',
    DBA_Doc9: 'DBA Document'
  };

  fieldMaxLengths: any = {

    Sales_tax_perc: 10,

    New_DBA_Name: 255,

    preferredDBAName: 255,

    Remove_DBA_Name: 255,

    Owner_Email_N: 80,

    Owner_Mobile_Phone_N: 40,

    Company_Office_Phone_N: 40,

    New_DBA_Name0: 255,
    New_DBA_Name1: 255,
    New_DBA_Name2: 255,
    New_DBA_Name3: 255,
    New_DBA_Name4: 255,
    New_DBA_Name5: 255,
    New_DBA_Name6: 255,
    New_DBA_Name7: 255,
    New_DBA_Name8: 255,
    New_DBA_Name9: 255,


  };

  constructor(private route: ActivatedRoute, private elRef: ElementRef, private fb: FormBuilder, private router: Router, private alertService: AlertService, private authService: AuthService, private configurations: ConfigurationService, private sfDataService: SfDataService, private agentService: AgentService, private hintStateService: AiHintStateService) { }

  @Output() activateTab = new EventEmitter<number>();

  ngOnInit(): void {


    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Attempting login...');
    //this.emitActivateTab(3);
    $('.detailchild').removeClass('active');
    $('.detailmain').removeClass('active');
    $('#custom-tabs-four-more-tab').addClass('active');

    $('.detailchild').removeClass('tabhighlight');
    $('#custom-tabs-change-off-info').addClass('tabhighlight');
    $('#custom-tabs-four-more-tab').parent().addClass('active');

    this.id = this.route.snapshot.paramMap.get('id');

    this.fm = this.route.snapshot.paramMap.get('f');

    this.d = this.route.snapshot.paramMap.get('dcode');
    //this.q = this.route.snapshot.paramMap.get('query');
    //if (this.q != null) {

    //  this.ShowOTPpopup("Enter Access Code to continue");
    //  $('#custom-tabs-four-home-tab').parent().addClass('hide');
    //  $('#custom-tabs-four-messages-tab').parent().addClass('hide');
    //  $('#custom-tabs-four-profile-tab').parent().addClass('hide');
    //}

    this.datad = this.inputData;
    this.CreateForm();

    this.BindDropdowns();
     
        this.idEmitter.emit(this.id);
    this.BindData(this.id);
    this.dbaRowsVisibility = Array(10).fill(false);
    this.dbaRowsVisibility[0] = true; 
  }


  addDBARow(): void {
    const firstHiddenIndex = this.dbaRowsVisibility.indexOf(false);
    if (firstHiddenIndex !== -1) {
      this.dbaRowsVisibility[firstHiddenIndex] = true; 
      
      this.icdForm.get('New_DBA_Name'+firstHiddenIndex).setValidators([Validators.required]);
      this.icdForm.get('DBA_Doc' + firstHiddenIndex).setValidators([Validators.required]);
      this.icdForm.get('DBA_Doc' + firstHiddenIndex).setValue(null);
     

      this.icdForm.get('New_DBA_Name' + firstHiddenIndex).updateValueAndValidity();
      this.icdForm.get('DBA_Doc' + firstHiddenIndex).updateValueAndValidity();
      //this.dbaRowsHighlight[firstHiddenIndex] = true;
    } else {
      alert('Maximum rows reached.');
    }
  }

  removeDBARow(index: number): void {
    this.dbaRowsVisibility[index] = false;
    //this.dbaRowsHighlight[index] = false;
    // Reset the form controls for the hidden row
    this.icdForm.get(`New_DBA_Name${index}`)?.reset();
    this.icdForm.get(`DBA_Doc${index}`)?.reset();

    this.icdForm.get('New_DBA_Name' + index).clearValidators();
    this.icdForm.get('DBA_Doc' + index).clearValidators();

    this.icdForm.get('New_DBA_Name' + index).updateValueAndValidity();
    this.icdForm.get('DBA_Doc' + index).updateValueAndValidity();

  } 


  @HostListener('contextmenu', ['$event'])
  onRightClick(event: Event): void {
    event.preventDefault();
  }
  ShowOTPpopup(str: string) {
    Swal.fire({
      title: 'OTP!',
      text: str,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,
      input: 'text',
      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (!val) {
          Swal.showValidationMessage("OTP is required");
        } else {
          try {

            // Create a new instance of the ICD class
            let responseAPI = new ResponseAPI();
            this.sfDataService.getOTP(this.id, val, this.q)
              .subscribe(
                data => {

                  //responseAPI = data;
                  // Assign the received data to the responseAPI object
                  responseAPI = data;
                  if (responseAPI.isSuccess) {
                    this.isOTPValid = responseAPI.isSuccess;
                    this.idEmitter.emit(this.id);
                    this.BindData(this.id);
                  }
                  else {
                    // API call failed, reject the Promise to prevent closing the popup
                    this.ShowOTPpopup("Wrong Access Code, Enter Access Code to continue");
                  }

                },
                error => {

                  this.alertService.stopLoadingMessage();

                  if (Utilities.checkNoNetwork(error)) {
                    this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
                    this.offerAlternateHost();
                  } else {
                    const errorMessage = Utilities.getHttpResponseMessage(error);

                    if (errorMessage) {
                      this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
                    } else {
                      this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
                    }
                  }

                  setTimeout(() => {
                    this.isLoading = false;
                  }, 500);
                });

            // await this.apiService.postData(val);
            // API call succeeded, resolve the Promise
          } catch (error) {
            // API call failed, reject the Promise to prevent closing the popup
            return Promise.reject(error);
          }
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle success case when the API call is successful
      } else if (result.isDenied) {
        // Handle the case when the user cancels the dialog
      } else if (result.isDismissed) {
        // Handle the case when the dialog is closed without confirmation
      }
    });
  }

  CreateForm() {
    this.icdForm = this.fb.group({
      US_or_CA:  [{ value: '', disabled: true }],
      Full_Legal_Company_Name:  [{ value: '', disabled: true }],
      
      Distributor_Code:  [{ value: '', disabled: true }],
      ICD_Owner_Name:  [{ value: '', disabled: true }],
      New_Address:  [{ value: '', disabled: true }],
      Company_Address2:  [{ value: '', disabled: true }],
      Company_City:  [{ value: '', disabled: true }],
      Company_Postal_Code:  [{ value: '', disabled: true }],
      Company_Office_Phone:  [{ value: '', disabled: true }],
      HUB_Manager_Contact_Name: [{ value: '', disabled: true }],
      Company_Country:  [{ value: '', disabled: true }],
      Company_State:  [{ value: '', disabled: true }],
      Company_Province:  [{ value: '', disabled: true }],
      Owner_Office_Phone:  [{ value: '', disabled: true }],

      Sales_tax_perc: ['', [Validators.maxLength(this.fieldMaxLengths.Sales_tax_perc), this.noHtmlTagsValidator.bind(this)]],
      New_DBA_Name: ['', [Validators.maxLength(this.fieldMaxLengths.New_DBA_Name), this.noHtmlTagsValidator.bind(this)]],
      isNew_DBA_Name: [''],
      isPreferredDBA: [''],
      preferredDBAName: [''],
      Remove_DBA_Name: ['', [Validators.maxLength(this.fieldMaxLengths.Remove_DBA_Name), this.noHtmlTagsValidator.bind(this)]],
      isRemove_DBA_Name: [''],
      Owner_Email: [{ value: '', disabled: true }],
      Owner_Email_N: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Email_N), this.noHtmlTagsValidator.bind(this)]],
      Owner_Mobile_Phone_N: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Mobile_Phone_N), elevenDigitPhoneNumberValidator()]],
      Sales_tax_perc_N: ['0'],
      Company_Office_Phone_N: ['', [Validators.maxLength(this.fieldMaxLengths.Company_Office_Phone_N), tenDigitPhoneNumberValidator()]],
      DBA_Doc: [{ value: '' }],


      Promoting_Owner: [{ value: '', disabled: true }],
      Promoting_Owner_Company: [{ value: '', disabled: true }],
      Regional_Consultant: [{ value: '', disabled: true }],
      Regional_Consultant_Company: [{ value: '', disabled: true }],
      National_Consultant: [{ value: '', disabled: true }],
      National_Consultant_Company: [{ value: '', disabled: true }],


      New_DBA_Name0: ['', [Validators.maxLength(this.fieldMaxLengths.New_DBA_Name0), this.noHtmlTagsValidator.bind(this)]],
      DBA_Doc0: [''],

      New_DBA_Name1: ['', [Validators.maxLength(this.fieldMaxLengths.New_DBA_Name1), this.noHtmlTagsValidator.bind(this)]],
      DBA_Doc1: [''],


      New_DBA_Name2: ['', [Validators.maxLength(this.fieldMaxLengths.New_DBA_Name2), this.noHtmlTagsValidator.bind(this)]],
      DBA_Doc2: [''],


      New_DBA_Name3: ['', [Validators.maxLength(this.fieldMaxLengths.New_DBA_Name3), this.noHtmlTagsValidator.bind(this)]],
      DBA_Doc3: [''],


      New_DBA_Name4: ['', [Validators.maxLength(this.fieldMaxLengths.New_DBA_Name4), this.noHtmlTagsValidator.bind(this)]],
      DBA_Doc4: [''],


      New_DBA_Name5: ['', [Validators.maxLength(this.fieldMaxLengths.New_DBA_Name5), this.noHtmlTagsValidator.bind(this)]],
      DBA_Doc5: [''],


      New_DBA_Name6: ['', [Validators.maxLength(this.fieldMaxLengths.New_DBA_Name6), this.noHtmlTagsValidator.bind(this)]],
      DBA_Doc6: [''],


      New_DBA_Name7: ['', [Validators.maxLength(this.fieldMaxLengths.New_DBA_Name7), this.noHtmlTagsValidator.bind(this)]],
      DBA_Doc7: [''],


      New_DBA_Name8: ['', [Validators.maxLength(this.fieldMaxLengths.New_DBA_Name8), this.noHtmlTagsValidator.bind(this)]],
      DBA_Doc8: [''],


      New_DBA_Name9: ['', [Validators.maxLength(this.fieldMaxLengths.New_DBA_Name9), this.noHtmlTagsValidator.bind(this)]],
      DBA_Doc9: [''],


      //Is_primary_location: ['', Validators.required],

    });


  }

  sendDataToParent() {
    this.dataEmitter.emit(this.datad);
  }
  // convenience getter for easy access to form fields
  get f() { return this.icdForm.controls; }

  get s1() { return this.section1Form.controls; }

  get items(): FormArray {
    return this.icdForm.get('items') as FormArray;
  }



  onCountryChange() {
    const US_or_CA = this.icdForm.get('US_or_CA').value;
    if (US_or_CA === 'US') {
      this.selectedCountry = "US";     
      this.icdForm.get('Company_Country').setValidators([Validators.required]);
      this.icdForm.get('Company_State').setValidators([Validators.required]);
      this.icdForm.get('Company_Province').clearValidators();


    } else {
      this.selectedCountry = "Canada";      
      this.icdForm.get('Company_Country').clearValidators();
      this.icdForm.get('Company_State').clearValidators();
      this.icdForm.get('Company_Province').setValidators([Validators.required]);
    }
    
    this.icdForm.get('Company_Country').updateValueAndValidity();
    this.icdForm.get('Company_State').updateValueAndValidity();
    this.icdForm.get('Company_Province').updateValueAndValidity();


  }


  onChangeisRemoveDBA() {
    const US_or_CA = this.icdForm.get('isRemove_DBA_Name').value;
    if (US_or_CA == true) {
      this.isRemove_DBA_Name = true;
      this.icdForm.get('Remove_DBA_Name').setValidators([Validators.required]);
      



    } else {
      this.isRemove_DBA_Name = false;
      this.icdForm.get('Remove_DBA_Name').clearValidators();
      

    }

    
    this.icdForm.get('Remove_DBA_Name').updateValueAndValidity();



  }

  onChangeisNewDBA() {
    const US_or_CA = this.icdForm.get('isNew_DBA_Name').value;
    if (US_or_CA == true) {
      this.isNew_DBA_Name = true;
      this.icdForm.get('New_DBA_Name0').setValidators([Validators.required]);
      this.icdForm.get('DBA_Doc0').setValidators([Validators.required]);
      
      this.icdForm.get('DBA_Doc0').setValue(null);

    } else {
      this.isNew_DBA_Name = false;
      this.icdForm.get('New_DBA_Name0').clearValidators();
      this.icdForm.get('DBA_Doc0').clearValidators();
      
      }

      

    this.icdForm.get('New_DBA_Name0').updateValueAndValidity();
    this.icdForm.get('DBA_Doc0').updateValueAndValidity();
    


    }


    onChangePreferredDBA() {
        const isPreferred = this.icdForm.get('isPreferredDBA').value;
        const preferredNameControl = this.icdForm.get('preferredDBAName');

        if (isPreferred === 'No') {
            preferredNameControl.setValidators([
                Validators.required,
                Validators.maxLength(255),
                this.noHtmlTagsValidator.bind(this)
            ]);
        } else {
            preferredNameControl.clearValidators();
        }

        preferredNameControl.updateValueAndValidity();
    }

  onCheckboxChange_US_Retails(event: any, value: any) {
    if (event.target.checked) {
      this.US_Retails_selectedItems.push(value);
    } else {
      const index = this.US_Retails_selectedItems.indexOf(value);
      if (index > -1) {
        this.US_Retails_selectedItems.splice(index, 1);
      }
    }


    if (this.US_Retails_selectedItems.length <= 0) {
      this.US_Retails_isSelectedItemsinvalid = true;
    }
    else {
      this.US_Retails_isSelectedItemsinvalid = false;
    }


  }


  onCheckboxChange_Canada_Retails(event: any, value: any) {
    if (event.target.checked) {
      this.Canada_Retails_selectedItems.push(value);
    } else {
      const index = this.Canada_Retails_selectedItems.indexOf(value);
      if (index > -1) {
        this.Canada_Retails_selectedItems.splice(index, 1);
      }
    }


    if (this.Canada_Retails_selectedItems.length <= 0) {
      this.Canada_Retails_isSelectedItemsinvalid = true;
    }
    else {
      this.Canada_Retails_isSelectedItemsinvalid = false;
    }


  }


  onCheckboxChange_US_Campaigns(event: any, value: any) {

    if (event.target.checked) {
      if (value == "TestCampaign(NotListed)") {
        this.isTestCampaign = true;
        this.icdForm.get('TestCampaignNotListed').setValidators([Validators.required]);
        this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();

      }
      this.US_Campaigns_selectedItems.push(value);
    } else {
      this.isTestCampaign = false;
      this.icdForm.get('Company_Country').clearValidators();
      this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();
      const index = this.US_Campaigns_selectedItems.indexOf(value);
      if (index > -1) {
        this.US_Campaigns_selectedItems.splice(index, 1);
      }
    }


    if (this.US_Campaigns_selectedItems.length <= 0) {
      this.US_Campaigns_isSelectedItemsinvalid = true;
    }
    else {
      this.US_Campaigns_isSelectedItemsinvalid = false;
    }


  }


  onCheckboxChange_Canada_Campaigns(event: any, value: any) {
    if (event.target.checked) {
      this.Canada_Campaigns_selectedItems.push(value);
    } else {
      const index = this.Canada_Campaigns_selectedItems.indexOf(value);
      if (index > -1) {
        this.Canada_Campaigns_selectedItems.splice(index, 1);
      }
    }


    if (this.Canada_Campaigns_selectedItems.length <= 0) {
      this.Canada_Campaigns_isSelectedItemsinvalid = true;
    }
    else {
      this.Canada_Campaigns_isSelectedItemsinvalid = false;
    }


  }

  onCheckboxPo(selectElement) {
    if (selectElement != null) {
      const selectedIndex = this.PO_namesData.filter(item => item.ownerName == selectElement);

      if (selectedIndex.length >= 0) {
        this.icdForm.controls['Promoting_Owner_Company'].setValue(selectedIndex[0].name);
      } else {
        this.icdForm.controls['Promoting_Owner_Company'].setValue('');
      }
    }
  }

  onCheckboxNC(selectElement) {
    if (selectElement != null) {
      const selectedIndex = this.NC_namesData.filter(item => item.ownerName == selectElement);

      if (selectedIndex.length >= 0) {
        this.icdForm.controls['National_Consultant_Company'].setValue(selectedIndex[0].name);
      } else {
        this.icdForm.controls['National_Consultant_Company'].setValue('');
      }
    }
  }

  onCheckboxRC(selectElement) {
    if (selectElement != null) {
      const selectedIndex = this.RC_namesData.filter(item => item.ownerName == selectElement);

      if (selectedIndex.length >= 0) {
        this.icdForm.controls['Regional_Consultant_Company'].setValue(selectedIndex[0].name);
      } else {
        this.icdForm.controls['Regional_Consultant_Company'].setValue('');
      }
    }
  }


  showErrorAlert(caption: string, message: string) {
    this.alertService.showMessage(caption, message, MessageSeverity.error);
  }
  ngAfterViewInit() {

    // $('#First_Date_New_Address').datepicker({
    //  dateFormat: 'yy-mm-dd',
    //  changeMonth: true,
    //  changeYear: true,
    //  // minDate: 0,
    //  onSelect: (dateText, inst) => {
    //    this.datepicker = dateText;
    //    this.icdForm.controls['First_Date_New_Address'].patchValue(dateText);
    //    this.icdForm.controls['First_Date_New_Address'].markAsTouched();
    //    this.icdForm.controls['First_Date_New_Address'].updateValueAndValidity();
    //  }
    //});

    //if (this.selectEl) {
    //  $(this.selectEl.nativeElement).select2({ width: '100%' });
    //};

    //setTimeout(() => {
    //  $('.select2', this.elRef.nativeElement).select2();
    //}, 0);
    $('.select2').select();
    //$(this.datepicker.nativeElement).datepicker({
    //  dateFormat: 'yyyy-mm-dd',
    //  autoclose: true,
    //  onSelect: (date) => {
    //    this.dobInput.nativeElement.value = date;
    //  }
    //});

    //$('.select2').select2(); //initialize 
  }

  closeModal() {
    if (this.modalClosedCallback) {
      this.modalClosedCallback();
    }
  }

  onSubmit() {
    this.hintStateService.collapse();

    this.submitted = true;

    // FR1: do not submit while a file is still uploading to staging.
    if (this.hasUploadsInFlight()) {
      this.alertService.showMessage('Please wait', 'A file is still uploading. Please wait until it finishes before submitting.', MessageSeverity.error);
      this.Showsuccesspopup1('A file is still uploading. Please wait until it finishes before submitting.');
      return;
    }

    this.trimFormValues();
    // stop here if form is invalid
    if (this.icdForm.invalid) {

      // Mark all fields as touched to display validation errors
      this.icdForm.markAllAsTouched();


      const formControls = this.icdForm.controls;

      // Initialize an array to store invalid controls
      const invalidControls: string[] = [];

      // Iterate through the form controls and check if they are invalid
      Object.keys(formControls).forEach(controlName => {
        const control = this.icdForm.get(controlName);

        if (control?.invalid) {

          let displayName =
            this.controlDisplayNames[controlName] || controlName;

          if (control.errors?.invalidHtml) {
            displayName += ' (HTML/script not allowed)';
          }
          invalidControls.push(displayName);
        }
      });

      // Now, the 'invalidControls' array contains the names of all invalid form controls
      ////console.log('Invalid controls:', invalidControls);
      const commaSeparated = invalidControls.join(', ');

      // Mark all fields as touched to display validation errors
      this.icdForm.markAllAsTouched();
      this.alertService.showMessage('Enter required fields', commaSeparated, MessageSeverity.error);
      this.Showsuccesspopup1('Enter required fields :' + commaSeparated);
      return;
    }


    this.showPreSubmitReview = true;
    this.runPreSubmitReview();

  }


  Showsuccesspopup1(str: string) {
    Swal.fire({
      title: str,
      icon: 'error',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {

          //location.reload();
        }
      },
    }).then((result) => {

    });
  }

  fileValidator(control: any) {
    const files = control.value;

    if (!files || files.length === 0) {
      return null;
    }
    if (files.length + this.fileData.length > this.maxFilesAllowed) {
      return { maxFilesExceeded: true };
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!this.isValidFileFormat(file)) {
        return { invalidFormat: true };
      }

      if (file.size > this.maxFileSize) {
        return { fileSizeExceeded: true };
      }
    }

    return null;
  }

  //onFileSelected(event: any, inputId: string) {

  //  const files = event.target.files;


  //  for (let i = 0; i < files.length; i++) {
  //    const file = files[i];

  //    if (!this.isValidFileFormat(file)) {
  //      //console.log('Invalid file format:', file.name);
  //      this.icdForm.get('Attach_US_Articles_of_Incorporation').setErrors({ invalidFormat: true });

  //      continue;
  //    }

  //    const reader = new FileReader();
  //    reader.readAsDataURL(file);

  //    reader.onload = () => {
  //      const base64 = reader.result.toString().split(',')[1];
  //      this.fileData.push({ name: file.name, base64 });

  //      // Update the 'Attach_1' form control with the selected file name
  //      this.icdForm.patchValue({ Attach_US_Articles_of_Incorporation: file.name });

  //    };
  //  }

  //  this.uploadFiles();
  //}

  onFileSelected(event: any, controlName: string) {
    const files = event.target.files;
    const errorMessages: string[] = [];
    if (!files || files.length === 0) {
      // Remove files only for the specific control
      this.fileData = this.fileData.filter(file => file.attachment_Type !== controlName);
      this.icdForm.get(controlName).setErrors({ noFileSelected: true });
      return;
    }

    // Remove previously selected files for this control while keeping others
    this.fileData = this.fileData.filter(file => file.attachment_Type !== controlName);


    const errors = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (!this.isValidFileFormat(file)) {
        errorMessages.push(
          `Invalid file format for "${file.name}". 
     Allowed formats: all image files (JPG, PNG, HEIC, etc.), PDF, Word (DOC, DOCX), Excel (XLS, XLSX), and CSV.`
        );

        //console.log('Invalid file format:', file.name);
        errors.push({ invalidFormat: true });
      }

      if (file.size > this.maxFileSize) {
        errorMessages.push(`File size exceeds 25 MB limit for file "${file.name}".`);
        //console.log('File size exceeds the limit:', file.name);
        errors.push({ fileSizeExceeded: true });
      }
    }

    if (errors.length > 0) {
      const combinedMessage = errorMessages.join('\n');

      this.alertService.showMessage(combinedMessage, '.', MessageSeverity.error);
      this.Showsuccesspopup1(combinedMessage);
      this.icdForm.get(controlName).setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
      const control = this.icdForm.get(controlName);
      // 🔥 CRITICAL FIX
      control?.setValue(null);
      control?.setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
      control?.markAsTouched();
      control?.updateValueAndValidity({ emitEvent: false });

      // optional: clear DOM input too
      event.target.value = '';
      return; // 👈 stop here
    } else {
      // ---------- SUCCESS: upload each file to staging on select (FR1) ----------
      this.uploadState[controlName] = 'uploading';
      this.uploadError[controlName] = '';
      const inputEl = event.target as HTMLInputElement;
      // Bump the selection counter; a superseded selection's FileReader result is discarded (FR2).
      const seq = this.uploadSeq[controlName] = (this.uploadSeq[controlName] || 0) + 1;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () => {
          if (this.uploadSeq[controlName] !== seq) { return; } // a newer selection superseded this one
          const b64 = reader.result!.toString().split(',')[1];
          const entry: { attachment_FileName: string, attachment_Base64: string, attachment_Type: string, FileId?: string, Url?: string, status?: 'uploading' | 'uploaded' | 'error' } = {
            attachment_FileName: file.name,
            attachment_Base64: b64,
            attachment_Type: controlName,
            status: 'uploading'
          };
          this.fileData.push(entry);
          this.triggerDocumentVerification(controlName);
          this.stageFile(entry, controlName, inputEl);
        };
      }

      this.icdForm.get(controlName).setErrors(null);
    }
  }

  // Uploads a single file to the staging area. A response from a previously replaced/cancelled
  // upload is ignored via object identity: if the entry is no longer in fileData, discard it (FR2).
  private stageFile(entry: any, controlName: string, inputEl: HTMLInputElement): void {
    const body = {
      CaseID: this.icd?.CaseID || this.icd?.AccountID || '',
      Attachment_FileName: entry.attachment_FileName,
      Attachment_Base64: entry.attachment_Base64,
      Owner_Email: this.icdForm?.get('Owner_Email')?.value || this.icd?.Owner_Email || this.icdForm?.get('Company_Business_Email')?.value || this.icd?.Company_Business_Email || this.icdForm?.get('HUB_Manager_Contact_Email')?.value || this.icd?.HUB_Manager_Contact_Email || this.icd?.HUB_Assistance_Email || '',
      Owner_Name: ((this.icd?.Owner_First_Name || '') + ' ' + (this.icd?.Owner_Last_Name || '')).trim(),
      Tax_ID: this.icd?.Tax_ID || ''
    };

    entry.StagingUniqueId = body.CaseID;

    this.sfDataService.stageAttachment(body).subscribe({
      next: (res: any) => {
        if (!this.fileData.includes(entry)) { return; } // superseded by a newer selection (FR2)
        if (res && res.isSuccess) {
          entry.FileId = res.fileId;
          entry.Url = res.url;
          entry.status = 'uploaded';
        } else {
          entry.status = 'error';
          this.removeStagedEntry(entry, inputEl);
          this.uploadError[controlName] = (res && res.errorMessage) ? res.errorMessage : 'Upload failed — please re-select the file.';
        }
        this.recomputeUploadState(controlName);
      },
      error: (err: any) => {
        if (!this.fileData.includes(entry)) { return; }
        entry.status = 'error';
        this.removeStagedEntry(entry, inputEl);
        this.uploadError[controlName] = this.extractServerError(err);
        this.recomputeUploadState(controlName);
      }
    });
  }

  // FR5: a failed file must not be silently submitted — drop it and force a re-select.
  private removeStagedEntry(entry: any, inputEl: HTMLInputElement): void {
    this.fileData = this.fileData.filter(f => f !== entry);
    const control = this.icdForm.get(entry.attachment_Type);
    if (inputEl) { inputEl.value = ''; }
    if (control?.hasValidator?.(Validators.required)) {
      control.setErrors({ required: true });
    }
    control?.markAsTouched();
  }

  private recomputeUploadState(controlName: string): void {
    const entries = this.fileData.filter(f => f.attachment_Type === controlName);
    if (entries.some(e => e.status === 'uploading')) {
      this.uploadState[controlName] = 'uploading';
    } else if (entries.length > 0 && entries.every(e => e.status === 'uploaded')) {
      this.uploadState[controlName] = 'uploaded';
      this.uploadError[controlName] = '';
    } else if (entries.length === 0 && this.uploadError[controlName]) {
      this.uploadState[controlName] = 'error';
    } else if (entries.length === 0) {
      delete this.uploadState[controlName];
    }
  }

  private extractServerError(err: any): string {
    try {
      if (err?.error?.errorMessage) { return err.error.errorMessage; }
      if (typeof err?.error === 'string' && err.error) { return err.error; }
      if (err?.message) { return err.message; }
    } catch { /* ignore */ }
    return 'Upload failed — please re-select the file.';
  }

  // FR1: block submission while any staged upload is still resolving.
  hasUploadsInFlight(): boolean {
    return this.fileData.some(f => f.status === 'uploading');
  }

  isInvalid(controlName: string): boolean {
    const control = this.icdForm.get(controlName);
    return control.touched && control.invalid;
  }


  public openFile(name: string, type: string): void {
    this.getBase64DownloadUrl(name, type).then((url: string) => {
      window.open(url, '_blank');
    });
  }

  public getBase64DownloadUrl(name: string, type: string): Promise<string> {
    const file = this.fileData.find(f => f.attachment_FileName === name && f.attachment_Type === type);

    if (file) {
      const fileExtension = this.getFileExtension(name);
      const mimeType = this.getMimeType(fileExtension);
      const base64Data = file.attachment_Base64;

      return Promise.resolve(`data:${mimeType};base64,${base64Data}`);
    } else {
      return Promise.reject(new Error('File not found.'));
    }
  }


  private getFileExtension(fileName: string): string {
    const fileExtension = fileName.split('.').pop().toLowerCase();
    return fileExtension;
  }


  private getMimeType(fileExtension: string): string {
    // Map the file extension to the corresponding MIME type
    const mimeTypeMap = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png'
    };

    return mimeTypeMap[fileExtension];
  }


  isValidFileFormat(file: File): boolean {
    const allowedMimePrefixes = [
      'image/' // all image types (jpg, png, heic, webp, etc.)
    ];

    const allowedExactMimeTypes = [
      // PDF
      'application/pdf',

      // Word
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

      // Excel
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

      // CSV (different browsers report it differently)
      'text/csv',
      'application/csv',
      'text/plain'
    ];

    // 1️⃣ Primary check (modern browsers)
    if (file.type) {
      if (allowedMimePrefixes.some(prefix => file.type.startsWith(prefix))) {
        return true;
      }

      if (allowedExactMimeTypes.includes(file.type)) {
        return true;
      }
    }

    // 2️⃣ Fallback (Safari / iOS / older browsers)
    const allowedExtensions = [
      // images
      'jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif',

      // documents
      'pdf', 'doc', 'docx',

      // excel
      'xls', 'xlsx',

      // csv
      'csv'
    ];

    const extension = file.name.split('.').pop()?.toLowerCase();
    return !!extension && allowedExtensions.includes(extension);
  }


  uploadFiles() {
    //const formData = new FormData();

    //for (let i = 0; i < this.validFiles.length; i++) {
    //  formData.append('files[]', this.validFiles[i]);
    //}

    //console.log(this.fileData)
    //this.http.post('https://example.com/upload', formData).subscribe(
    //  (response) => {
    //    //console.log('Upload successful', response);
    //  },
    //  (error) => {
    //    //console.log('Upload error', error);
    //  }
    //);
  }


  // Check if the first five fields are valid
  areFirstFiveFieldsValid(firstFiveFields: any): boolean {


    for (const fieldName of firstFiveFields) {
      const fieldControl = this.icdForm.get(fieldName);
      if (fieldControl && fieldControl.invalid) {
        return false;
      }
    }

    return true;
  }

  // Example implementation of getErrorMessage function
  getErrorMessage(fieldName: string): string {
    const control = this.icdForm.get(fieldName);

    if (control?.errors) {
      if (control.errors.required) {
        return 'This field is required.';
      }
      // Add additional error messages for specific validation rules as needed
    }

    return 'Invalid field.';
  }
   
  saveData(isSubmitted: boolean) {
    //debugger;
    

    // Get the form values as an object
    const formValues = this.icdForm.getRawValue();



    // Set the properties of the ICD instance with the form values
    //this.icd.US_or_CA = formValues.US_or_CA;
    //this.icd.Full_Legal_Company_Name = formValues.Full_Legal_Company_Name;
    // this.icd.Years_in_Business = formValues.Years_in_Business;
    
    this.icd.Sales_tax_perc = formValues.Sales_tax_perc;

    this.icd.Owner_Office_Phone_N = formValues.Owner_Mobile_Phone_N;
    this.icd.Company_Office_Phone_N = formValues.Company_Office_Phone_N;
    this.icd.Owner_Email_N = formValues.Owner_Email_N;
    this.icd.Sales_tax_perc_N = formValues.Sales_tax_perc_N;
    if (formValues.isNew_DBA_Name == '') {
      formValues.isNew_DBA_Name = false;
      }
      this.icd.isNew_DBA_Name = formValues.isNew_DBA_Name;
      this.icd.New_DBA_Name = formValues.New_DBA_Name0 || formValues.New_DBA_Name;
    
     
    if (formValues.isRemove_DBA_Name == '') {
      formValues.isRemove_DBA_Name = false;
    }
    this.icd.isRemove_DBA_Name = formValues.isRemove_DBA_Name;
    
      this.icd.Remove_DBA_Name = formValues.Remove_DBA_Name;
      this.icd.IsPreferredDBA = formValues.isPreferredDBA;
      this.icd.PreferredDBAName = formValues.preferredDBAName;
   
    //if (this.icd.US_or_CA == "US") {

    //  const attachFields = [
    //    'DBA_Doc'
    //  ];

    //  for (const field of attachFields) {
    //    const filteredBase64Array = this.fileData
    //      .filter(file => file.attachment_Type === field)
    //      .map(file => file.attachment_Base64);

    //    const commaSeparatedBase64 = filteredBase64Array.join('$$$');

    //    this.icd[field] = commaSeparatedBase64;
    //  }


    //}
    //else {

    //  const attachCanadaFields = [
    //    'DBA_Doc'
    //  ];

    //  for (const field of attachCanadaFields) {
    //    const filteredBase64Array = this.fileData
    //      .filter(file => file.attachment_Type === field)
    //      .map(file => file.attachment_Base64);

    //    const commaSeparatedBase64 = filteredBase64Array.join('$$$');

    //    this.icd[field] = commaSeparatedBase64;
    //  }



    //}

    // Collecting DBA Names and Docs dynamically
    const dbaData = [];

    for (let i = 0; i < 10; i++) {
      const nameField = formValues[`New_DBA_Name${i}`];
      const docField = formValues[`DBA_Doc${i}`];

      if (nameField || docField) {
        // Validate: Ensure doc is mandatory if name is entered
        if (nameField && !docField) {
          console.error(`Document is required for DBA Name: ${nameField}`);
          this.alertService.showMessage('ICD', `Document is required for DBA Name: ${nameField}`, MessageSeverity.error);
          return; // Stop submission
        }

        if (!nameField && docField) {
          
          this.alertService.showMessage('ICD', `DBA Name is required for Document : ${nameField}`, MessageSeverity.error);
          return; // Stop submission
        }

        dbaData.push({
          DBA_Name: nameField,
          //DBA_Doc: this.fileData
          //  .filter(file => file.attachment_Type === `DBA_Doc${i}`)
          //  .map(file => file.attachment_Base64)
          //  .join('$$$'),
        });
      }
    }

    this.icd.DBA_Data = dbaData; // Assign collected DBA data to the icd object

    this.icd.Attachments = this.fileData.filter(f => f.status === 'uploaded');

    this.icd.IsSubmitted = isSubmitted;
    this.isLoading = true;
    this.btnDisplay = false;
    this.alertService.startLoadingMessage('', 'Data Submitting...');
    //console.log(this.icd);
    this.SaveDatatoDB();

  }


  ShowSuccesspopup() {
    Swal.fire({
      title: 'Data Saved Successfully!',
      icon: 'success',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {

        }
      },
    }).then((result) => {
      let url = '/icdreport/';
      this.router.navigate([url]);
    });
  }


  SaveDatatoDB() {

    Swal.fire({
      title: 'Submitting data...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    // Create a new instance of the ICD class
    let responseAPI = new ResponseAPI();
    this.sfDataService.ChangeOfficeInfo(this.icd)
      .subscribe(
        data => {
          Swal.close();
          //responseAPI = data;
          // Assign the received data to the responseAPI object
          responseAPI = data;
          if (responseAPI.isSuccess && !responseAPI.isValidationError) {
            //location.reload();

            this.alertService.showMessage('ICD', `Data Saved Successfully`, MessageSeverity.success);
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.ShowSuccesspopup();
            //setTimeout(() => {
            //  this.alertService.showMessage('ICD', `Data Saved Successfully`, MessageSeverity.success);
            //  this.alertService.stopLoadingMessage();
            //  this.isLoading = false;


            //}, 200);
          }
          else {
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.btnDisplay = true;

            // FR6: surface the real server message (e.g. document move/confirm failure) rather
            // than a generic error, and guard against a missing ErrorList payload.
            const serverMessage = responseAPI.description
              || (responseAPI.data && responseAPI.data.error && responseAPI.data.error.message)
              || 'An error occurred while saving data. Please try again.';
            const errorCode = (responseAPI.data && responseAPI.data.error && responseAPI.data.error.errorCode) || '';

            this.alertService.showMessage('ICD', 'Submission failed', MessageSeverity.error);
            this.alertService.showStickyMessage('Unable to store data', serverMessage, MessageSeverity.error, errorCode);
          }

        },
        error => {
          Swal.close();
          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });

  }

  numberValidator(control: FormControl) {
    const isValid = /^\d+$/.test(control.value);
    return isValid ? null : { 'invalidNumber': true };
  }

  BindDropdowns() {
    //debugger;
    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');

    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    this.sfDataService.getMasterConfigs("US_State,Canada_Province,US_Retails,US_Campaigns,Canada_Retails,Canada_Campaigns,DeliveryTime")
      .subscribe(
        data => {
          ////console.log(data);
          //debugger;
          this.masterConfig = data;
          this.ddlUSStates = this.masterConfig.filter(a => a.type == "US_State");
          this.ddlCAProvinence = this.masterConfig.filter(a => a.type == "Canada_Province");
          //this.Canada_campaignData = this.masterConfig.filter(a => a.type == "Canada_Campaigns");
          //   this.Canada_retailsData = this.masterConfig.filter(a => a.type == "Canada_Retails");
          // this.US_campaignData = this.masterConfig.filter(a => a.type == "US_Campaigns");
          //  this.US_retailsData = this.masterConfig.filter(a => a.type == "US_Retails");
          this.ddlBest_Delivery_Time = this.masterConfig.filter(a => a.type == "DeliveryTime");
          this.alertService.stopLoadingMessage();
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });

    this.sfDataService.getAddInfoDDs().subscribe(resp => {
      ////console.log(resp);

      let res: any;

      res = resp;

      this.NC_namesData = res.ncNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));;
      this.RC_namesData = res.rcNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));;
      this.PO_namesData = res.poNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));;
      
      ////console.log(this.NC_namesData)

      ////console.log(this.Canada_campaignData)
    });

    

  }

  private mapDataToICD(data: any) {
    if (data == null) {

      this.icdForm.disable();
      this.alertService.showMessage('ICD', `This Case is not assigned to view`, MessageSeverity.error);
      this.alertService.startLoadingMessage('', 'This Case is not assigned to view');
      this.alertService.showStickyMessage('ICD', 'This Case is not assigned to view', MessageSeverity.error, "");
      this.btnDisplay = false;
      
      return;
    }
    //debugger;
    this.icdForm.controls['US_or_CA'].setValue(data.uS_or_CA);
    this.onCountryChange();
    this.icdForm.controls['Full_Legal_Company_Name'].setValue(data.full_Legal_Company_Name);
     
    this.icdForm.controls['ICD_Owner_Name'].setValue(data.owner_Name);

    //this.icdForm.controls['Company_Address2'].setValue(data.hUB_Manager_Contact_Email);
    this.icdForm.controls['Company_City'].setValue(data.homeCity);
    this.icdForm.controls['Company_Postal_Code'].setValue(data.homeZipCode);
    this.icdForm.controls['Company_Office_Phone'].setValue(data.homePhone);

    //this.icdForm.controls['Company_Country'].setValue(data.hUB_Manager_Contact_Email);
    this.icdForm.controls['Company_State'].setValue(data.homeState);
    this.icdForm.controls['Company_Province'].setValue(data.homeState);
    this.icdForm.controls['Owner_Office_Phone'].setValue(data.owner_Office_Phone);
    this.icdForm.controls['HUB_Manager_Contact_Name'].setValue(data.huB_Manager_Contact_Name);
    this.icdForm.controls['Owner_Email'].setValue(data.owner_Email);
    this.icdForm.controls['Promoting_Owner'].setValue(data.promotingOwner);
    this.icdForm.controls['Promoting_Owner_Company'].setValue(data.promotingOwnerCompany);
    this.icdForm.controls['Regional_Consultant'].setValue(data.regionalConsultant);
    this.icdForm.controls['Regional_Consultant_Company'].setValue(data.regionalConsultantCompany);
    this.icdForm.controls['National_Consultant'].setValue(data.nationalConsultant);
    this.icdForm.controls['National_Consultant_Company'].setValue(data.nationalConsultantCompany);

    ////console.log(data);


    if (this.d != null) {
      this.icdForm.controls['Distributor_Code'].setValue(this.d);
      this.icd.Distributor_Code = this.d;
    }


    this.icd.AccountID = data.accountID;
    
    this.icd.HUB_Manager_Contact = data.huB_Manager_Contact;
    this.icd.HUB_Manager_Contact_Name = data.huB_Manager_Contact_Name;
    this.icd.HUB_Manager_Contact_Number = data.huB_Manager_Contact_Number;
    this.icd.HUB_Manager_Contact_Email = data.huB_Manager_Contact_Email;
    this.icd.HUB_Assistance_Email = data.huB_Assistance_Email;
    this.icd.US_or_CA = data.uS_or_CA;
    this.icd.Tax_ID = data.tax_ID;
    this.icd.Company_Address1 = data.homeAddress;
    this.icd.Company_Address2 = data.homeAddress2;
    this.icd.Company_City = data.homeCity;
    this.icd.Company_Postal_Code = data.homeZipCode;
    this.icd.Company_Office_Phone = data.homePhone;
    this.icd.Company_State = data.homeState;
    this.icd.Company_Province = data.homeState;
    this.icd.Owner_Office_Phone = data.owner_Office_Phone;
    this.icd.Full_Legal_Company_Name = data.full_Legal_Company_Name;
    this.icd.Owner_First_Name = data.owner_First_Name;
    this.icd.Owner_Last_Name = data.owner_Last_Name;
    this.icd.Owner_Email = data.owner_Email;
    this.icd.Owner_Name = data.owner_Name;
    this.icd.PromotingOwner = data.promotingOwner;
    this.icd.PromotingOwnerCompany = data.promotingOwnerCompany;
    this.icd.RegionalConsultant = data.regionalConsultant;
    this.icd.RegionalConsultantCompany = data.regionalConsultantCompany;
    this.icd.NationalConsultant = data.nationalConsultant;
    this.icd.NationalConsultantCompany = data.nationalConsultantCompany;
    this.icd.CaseID = data.caseID;
    this.icd.ContactID = data.contactID;
    
    
    this.dataEmitter.emit(this.datad);


  }

  BindData(id: string) {
    //debugger;

    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');
    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    if (this.f != null && this.d != null) {
      this.sfDataService.getICDStep3byAcc(id)
        .subscribe(
          data => {
            ////console.log(data);
            //debugger;

            this.mapDataToICD(data);
            ////console.log(data);


            this.alertService.stopLoadingMessage();
          },
          error => {

            this.alertService.stopLoadingMessage();

            if (Utilities.checkNoNetwork(error)) {
              this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
              this.offerAlternateHost();
            } else {
              const errorMessage = Utilities.getHttpResponseMessage(error);

              if (errorMessage) {
                this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
              } else {
                this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
              }
            }

            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
}
    else {
      this.sfDataService.getICDStep3(id)
        .subscribe(
          data => {
            ////console.log(data);
            //debugger;

            this.mapDataToICD(data);
            ////console.log(data);


            this.alertService.stopLoadingMessage();
          },
          error => {

            this.alertService.stopLoadingMessage();

            if (Utilities.checkNoNetwork(error)) {
              this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
              this.offerAlternateHost();
            } else {
              const errorMessage = Utilities.getHttpResponseMessage(error);

              if (errorMessage) {
                this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
              } else {
                this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
              }
            }

            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
}
    
  }

  mapLoginErrorMessage(error: string) {

    if (error === 'invalid_username_or_password') {
      return 'Invalid username or password';
    }

    if (error === 'invalid_grant') {
      return 'This account has been disabled';
    }

    return error;
  }

  offerAlternateHost() {

    if (Utilities.checkIsLocalHost(location.origin) && Utilities.checkIsLocalHost(this.configurations.baseUrl)) {
      this.alertService.showDialog('Dear Developer!\nIt appears your backend Web API service is not running...\n' +
        'Would you want to temporarily switch to the online Demo API below?(Or specify another)',
        DialogType.prompt,
        (value: string) => {
          this.configurations.baseUrl = value;
          this.alertService.showStickyMessage('API Changed!', 'The target Web API has been changed to: ' + value, MessageSeverity.warn);
        },
        null,
        null,
        null,
        this.configurations.fallbackBaseUrl);
    }
  }



  trimFormValues() {

    // Avoid setting value on file inputs. Skip controls that look like file attachments
    // (names starting with "Attach_") or whose value is a File/FileList/object.
    Object.keys(this.icdForm.controls).forEach(key => {
      // Skip known file-type controls
      if (/^Attach_/i.test(key) || /Attach/i.test(key)) {
        return;
      }

      const control = this.icdForm.get(key);
      if (!control) {
        return;
      }

      const val = control.value;

      // Skip File / FileList / object values to avoid InvalidStateError
      if (val instanceof File || (typeof FileList !== 'undefined' && val instanceof FileList) || typeof val === 'object') {
        return;
      }

      if (typeof val === 'string') {
        try {
          control.setValue(val.trim());
        } catch (e) {
          // don't break form processing on single control error
          console.warn(`trimFormValues: skipped trimming control '${key}' due to error`, e);
        }
      }
    });
  }

  noHtmlTagsValidator(control: any) {

  if (!control.value) {
    return null;
  }

  const value = control.value.toString().trim();

  const htmlPattern =
    /(<[^>]+>|&lt;|&gt;|javascript:|onerror=|onload=|<script|<\/script>)/gi;

  if (htmlPattern.test(value)) {
    return { invalidHtml: true };
  }

  return null;
}
  reset() {
    this.formResetToggle = false;

    setTimeout(() => {
      this.formResetToggle = true;
    });
  }
  buildFormSnapshot(): Record<string, string> {
    const raw = this.icdForm.getRawValue();
    const snap: Record<string, string> = {};
    Object.keys(raw).forEach(k => {
      const ctrl = this.icdForm.get(k);
      if (ctrl && ctrl.disabled) { return; } // skip disabled/read-only fields — user cannot act on the advisory
      const v = raw[k];
      if (v !== null && v !== undefined && v !== '' && typeof v !== 'object') {
        snap[k] = String(v);
      }
    });
    return snap;
  }

  runPreSubmitReview(): void {
    this.preSubmitLoading = true;
    this.preSubmitIssues = [];
    const snapshot = this.buildFormSnapshot();
    this.agentService.getPreSubmitReview(snapshot).pipe(
      catchError(() => of({ issues: [] }))
    ).subscribe(res => {
      this.preSubmitIssues = res?.issues ?? [];
      this.preSubmitLoading = false;
    });
  }

  onPreSubmitDismiss(): void { this.showPreSubmitReview = false; }

  onPreSubmitDoSubmit(): void {
    this.showPreSubmitReview = false;
    this.saveData(true);
  }

  onPreSubmitRecheck(): void { this.runPreSubmitReview(); }

  onPreSubmitAutoFix(fix: { fieldName: string; suggestedFix: string }): void {
    const ctrl = this.icdForm.get(fix.fieldName);
    if (ctrl) { ctrl.setValue(fix.suggestedFix); ctrl.markAsDirty(); }
  }

  onPreSubmitNavigate(fieldName: string): void {
    const el = document.getElementById(fieldName) || document.querySelector(`[formcontrolname="${fieldName}"]`);
    if (el) (el as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  private triggerDocumentVerification(controlName: string): void {
    const docType = this.VERIFIED_DOC_TYPES[controlName];
    if (!docType) return;

    const fileEntry = this.fileData.find(f => f.attachment_Type === controlName);
    if (!fileEntry) return;

    this.verificationState[controlName] = 'verifying';
    this.verificationIssues[controlName] = [];

    const ext = fileEntry.attachment_FileName.split('.').pop()?.toLowerCase() ?? '';
    const mimeMap: Record<string, string> = {
      pdf: 'application/pdf', jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', xls: 'application/vnd.ms-excel', csv: 'text/csv'
    };
    const mimeType = mimeMap[ext] ?? 'application/octet-stream';

    const formValues = this.icdForm.getRawValue();
    const body = {
      documentType: docType,
      base64Content: fileEntry.attachment_Base64,
      mimeType,
      companyName: (() => {
        const dbaMatch = controlName.match(/^DBA_Doc(\d)$/);
        if (dbaMatch) return formValues[`New_DBA_Name${dbaMatch[1]}`] || '';
        return formValues.Full_Legal_Company_Name || '';
      })(),
      taxId: formValues.Tax_ID || '',
      stateOfIncorporation: formValues.State_of_Incorporation || '',
      provinceOfIncorporation: formValues.Provinence_of_Incorporation || '',
      dateOfIncorporation: '',
    };

    this.sfDataService.verifyDocument(body).subscribe({
      next: (result: any) => {
        if (result.overallPass) {
          this.verificationState[controlName] = result.issues && result.issues.length > 0 ? 'warn' : 'pass';
        } else {
          this.verificationState[controlName] = 'warn';
        }
        this.verificationIssues[controlName] = result.issues || [];
      },
      error: () => {
        this.verificationState[controlName] = 'warn';
        this.verificationIssues[controlName] = ['Document verification unavailable — please verify manually.'];
      }
    });
  }


}


